import axios, { AxiosResponse } from "axios";
import { IAccountApi } from "./IAccountApi";

class AccountApi implements IAccountApi {
    private baseUrl: string;

    constructor() {
        this.baseUrl = '/Umbraco/Api/AccountApi';
    }

    public async uploadAvatar(file : File) : Promise<AxiosResponse<any, any>> {
        const url = `${this.baseUrl}/UpdateMemberAvatar`;
        const fd = new FormData();
        fd.append("avatar", file);

        const response = await axios.post(url, fd, {withCredentials: true });

        return response;
    }
}

const accountApi = new AccountApi();

export default accountApi;